import { Grid } from "@mui/material";
import Section from "../../../../components/section/section";
import React from "react";
import FromDateInput from "./fromDateInput";
import TillDateInput from "./tillDateInput";
import SearchButton from "./searchButton";
import ExportCsvButton from "./exportCsvButton";
import FoundResultsText from "./foundResultsText";

const SearchControls = (): React.JSX.Element => (
  <Section>
    <Grid container spacing={2}>
      <Grid item xs={12} sm md>
        <FromDateInput />
      </Grid>

      <Grid item xs={12} sm md>
        <TillDateInput />
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <SearchButton />
        <ExportCsvButton />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          textAlign: "center",
        }}
      >
        <FoundResultsText />
      </Grid>
    </Grid>
  </Section>
);

export default SearchControls;
